export default __webpack_public_path__ + "static/media/ProgressStage6b.2706d0ea.svg";